export type HolidayDefinition =
  | {
      type: 'fixed'
      month: number
      day: number
      name: string
    }
  | {
      type: 'easter'
      offsetDays: number
      name: string
    }

export const germanPublicHolidays: HolidayDefinition[] = [
  { type: 'fixed', month: 1, day: 1, name: 'Neujahr' },
  { type: 'easter', offsetDays: -2, name: 'Karfreitag' },
  { type: 'easter', offsetDays: 1, name: 'Ostermontag' },
  { type: 'fixed', month: 5, day: 1, name: 'Tag der Arbeit' },
  { type: 'easter', offsetDays: 39, name: 'Christi Himmelfahrt' },
  { type: 'easter', offsetDays: 50, name: 'Pfingstmontag' },
  { type: 'fixed', month: 10, day: 3, name: 'Tag der Deutschen Einheit' },
  { type: 'fixed', month: 12, day: 25, name: '1. Weihnachtstag' },
  { type: 'fixed', month: 12, day: 26, name: '2. Weihnachtstag' },
]
